import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient } from '@nike/fetch-client';
import getProductFeedThreadsQueryKey from './get-query-key';
import { transformsFeedData, getChannelId } from './utils';
import getFetchGlobalConfigOptions from "../../global-config/get-options";
import getWebShellClientLocale from "../../../utils/get-webshellclient-locale";
import getFetchValueAddedServicesOptions from "../../merch/value-added-services/v1/fetch/get-options";
var fetchProductFeedThreadsList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var productId, styleColor, globalConfig, _getWebShellClientLoc, language, country, marketplaceId, channelId, marketplace, productFilter, filters, fields, qs;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          productId = _ref.productId, styleColor = _ref.styleColor, globalConfig = _ref.globalConfig;
          _getWebShellClientLoc = getWebShellClientLocale(), language = _getWebShellClientLoc.language, country = _getWebShellClientLoc.country, marketplaceId = _getWebShellClientLoc.marketplaceId;
          channelId = getChannelId(country);
          marketplace = globalConfig !== null && globalConfig !== void 0 && globalConfig.useMarketplaceId ? marketplaceId : country === null || country === void 0 ? void 0 : country.toUpperCase(); // support for both productId and styleColor during CPA cutover. Hopefully product content APIs are finished before we retire product id.
          productFilter = productId ? "productInfo.merchProduct.id(".concat(productId, ")") : "publishedContent.properties.products.styleColor(".concat(styleColor, ")");
          filters = ["marketplace(".concat(marketplace, ")"), "language(".concat(language, ")"), "channelId(".concat(channelId, ")"), productFilter, "exclusiveAccess(true,false)" // Query all exclusive and non exclusive offers for a product.
          ];
          fields = ['productInfo.merchProduct', 'productInfo.productContent', 'productInfo.imageUrls', 'publishedContent'];
          qs = [filters.map(function (filter) {
            return "filter=".concat(filter);
          }).join('&'), "fields=".concat(fields.join(','))].filter(function (x) {
            return x;
          }); // filter out falsy values
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/product_feed/threads/v2/?").concat(qs.join('&'))));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchProductFeedThreadsList(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getFetchProductFeedThreadsOptions = function getFetchProductFeedThreadsOptions(_ref3) {
  var queryClient = _ref3.queryClient,
    productId = _ref3.productId,
    styleColor = _ref3.styleColor,
    fetchVasContent = _ref3.fetchVasContent;
  return {
    queryKey: getProductFeedThreadsQueryKey({
      productId: productId,
      styleColor: styleColor,
      fetchVasContent: fetchVasContent
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _transformedProductDa;
        var data, transformedProductData, vasPromises, vasPromisesData, _t, _t2, _t3, _t4;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _t = fetchProductFeedThreadsList;
              _t2 = productId;
              _t3 = styleColor;
              _context2.next = 1;
              return queryClient.fetchQuery(getFetchGlobalConfigOptions());
            case 1:
              _t4 = _context2.sent;
              _context2.next = 2;
              return _t({
                productId: _t2,
                styleColor: _t3,
                globalConfig: _t4
              });
            case 2:
              data = _context2.sent;
              transformedProductData = transformsFeedData(data); // fetch additional merch value added service related data
              if (!(fetchVasContent && (transformedProductData === null || transformedProductData === void 0 || (_transformedProductDa = transformedProductData.valueAddedServices) === null || _transformedProductDa === void 0 ? void 0 : _transformedProductDa.length) > 0)) {
                _context2.next = 4;
                break;
              }
              vasPromises = transformedProductData.valueAddedServices.map(function (vas) {
                return queryClient.fetchQuery(getFetchValueAddedServicesOptions({
                  id: vas.id
                }));
              });
              _context2.next = 3;
              return Promise.all(vasPromises);
            case 3:
              vasPromisesData = _context2.sent;
              transformedProductData.valueAddedServices = transformedProductData.valueAddedServices.map(function (vas) {
                var valueAddedService = vasPromisesData.filter(function (vasDatum) {
                  return vas.id === vasDatum.id;
                })[0] || [];
                return _objectSpread(_objectSpread({}, vas), {}, {
                  valueAddedService: valueAddedService
                });
              });
            case 4:
              return _context2.abrupt("return", transformedProductData);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: Infinity
  };
};
export default getFetchProductFeedThreadsOptions;